var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignalboxAttributionDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 17,
    viewBox: "0 0 75 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2487 16.4358C32.4891 16.3257 31.7376 16.0446 31.1902 15.6658C30.9875 15.5255 30.8084 15.3774 30.8083 15.35C30.8083 15.3331 31.4222 14.5652 31.5423 14.432C31.5463 14.4276 31.6268 14.4965 31.7212 14.5853C32.4536 15.2742 33.553 15.5796 34.5566 15.3728C35.1604 15.2484 35.6268 14.8975 35.8811 14.3765C36.074 13.9811 36.1318 13.6589 36.1498 12.8781C36.1626 12.3203 36.1558 12.2225 36.1045 12.2225C36.0882 12.2225 36.0267 12.2831 35.9678 12.3571C35.5794 12.8452 35.0418 13.1467 34.3486 13.2649C34.1295 13.3023 34.0302 13.3079 33.7368 13.2989C33.5443 13.293 33.303 13.2728 33.2008 13.2539C32.0864 13.0485 31.212 12.287 30.8532 11.2092C30.716 10.7971 30.6924 10.6302 30.6919 10.0685C30.6916 9.61453 30.6969 9.53411 30.7409 9.32834C31.0284 7.98544 31.9664 7.05009 33.2455 6.831C33.5498 6.77889 34.0467 6.77536 34.3326 6.82327C34.5658 6.86235 34.9681 6.99079 35.1615 7.08792C35.494 7.25486 35.8184 7.53347 36.0083 7.81502C36.1688 8.05306 36.1756 8.03927 36.1823 7.46354L36.188 6.97013L36.7662 6.96449L37.3445 6.95884V10.0963C37.3445 12.1524 37.3368 13.3137 37.322 13.4656C37.1935 14.7863 36.6533 15.6303 35.6173 16.129C35.3351 16.2648 35.104 16.3384 34.7463 16.4062C34.4412 16.464 33.5632 16.4813 33.2487 16.4358ZM34.6282 12.2374C35.641 11.9702 36.2822 11.0535 36.2341 9.94119C36.2109 9.40441 36.0476 8.95784 35.7306 8.5645C35.4542 8.22147 35.0021 7.93218 34.5751 7.82515C34.3081 7.75824 33.7455 7.75824 33.4997 7.82516C32.7805 8.02098 32.2622 8.50408 32.032 9.19307C31.8261 9.80951 31.8601 10.5293 32.1217 11.0874C32.4137 11.7105 32.9752 12.1512 33.638 12.2774C33.881 12.3236 34.3771 12.3036 34.6282 12.2374ZM24.0173 13.4722C23.213 13.3804 22.4219 13.0662 21.8845 12.6252C21.6842 12.4608 21.4233 12.188 21.4318 12.152C21.4357 12.1359 21.6346 11.9576 21.8739 11.7557C22.1131 11.5538 22.3263 11.3736 22.3476 11.3552C22.3838 11.324 22.3915 11.3282 22.4625 11.4167C22.7866 11.8209 23.3137 12.179 23.7838 12.3143C24.4079 12.4939 25.1371 12.4238 25.6426 12.1355C25.9462 11.9624 26.2371 11.6413 26.3523 11.352C26.499 10.9836 26.486 10.463 26.3218 10.1329C26.1645 9.81679 25.9046 9.58284 25.471 9.36712C25.2614 9.26289 25.0113 9.16917 24.4311 8.97753C23.5922 8.70045 23.4222 8.637 23.1372 8.49457C22.8461 8.34907 22.6041 8.17923 22.4024 7.97891C21.9969 7.57609 21.7986 7.13661 21.7435 6.51871C21.6849 5.86082 21.8415 5.24789 22.1871 4.78248C22.7223 4.06179 23.5556 3.66205 24.6821 3.58568C25.7119 3.51587 26.7739 3.83965 27.4347 4.42493C27.6676 4.63118 27.6825 4.58189 27.2605 4.9998C27.0583 5.20003 26.8611 5.39009 26.8223 5.42215L26.7517 5.48045L26.6173 5.34204C26.1601 4.87112 25.5708 4.62548 24.898 4.62534C24.4583 4.62526 23.9635 4.76415 23.6683 4.97054C23.4202 5.14402 23.1609 5.47742 23.0806 5.72605C23.018 5.92 23.0021 6.33881 23.0497 6.54175C23.133 6.89764 23.3499 7.17257 23.7283 7.4018C23.9259 7.52156 24.2124 7.63407 24.9086 7.86539C25.7063 8.13045 26.0943 8.27346 26.3092 8.3817C26.699 8.57798 27.0799 8.88474 27.3089 9.18673C27.4473 9.36929 27.6137 9.70873 27.6663 9.91565C27.7644 10.3022 27.7743 10.8312 27.6914 11.2581C27.5345 12.066 27.0443 12.7054 26.2866 13.0905C25.6489 13.4147 24.7856 13.5599 24.0173 13.4722ZM57.3673 13.4188C56.7601 13.3529 56.1634 13.0912 55.7582 12.713C55.7005 12.6592 55.5917 12.5363 55.5164 12.4401C55.38 12.2655 55.3355 12.2349 55.3111 12.2985C55.304 12.317 55.2982 12.5414 55.2982 12.7973V13.2624H54.7252H54.1522V8.21128V3.16016L54.7411 3.16579L55.33 3.17143L55.3406 5.52705C55.3512 7.8683 55.3515 7.88271 55.394 7.8888C55.4241 7.89313 55.4607 7.86353 55.5179 7.78853C55.7152 7.52983 56.1136 7.20902 56.4406 7.04553C56.6021 6.96484 56.8877 6.87014 57.0914 6.82979C57.3231 6.7839 58.1019 6.78957 58.3329 6.83882C58.9719 6.97508 59.4858 7.2574 59.9184 7.70993C60.5086 8.32729 60.8168 9.14836 60.8154 10.0998C60.8139 10.998 60.5279 11.8046 59.9908 12.4234C59.5703 12.9079 58.9285 13.2622 58.2586 13.3797C58.0693 13.4129 57.5306 13.4366 57.3673 13.4188ZM57.7945 12.4053C58.5201 12.2964 59.1192 11.8191 59.395 11.1304C59.5262 10.8028 59.5677 10.592 59.5792 10.1958C59.5913 9.77258 59.5627 9.5628 59.4434 9.2037C59.2628 8.66015 58.8952 8.22925 58.4072 7.98925C58.0892 7.83288 57.923 7.7993 57.4628 7.79848C57.1187 7.79788 57.0483 7.80376 56.8933 7.84616C56.0826 8.06782 55.4789 8.7536 55.3063 9.64886C55.2588 9.89528 55.2588 10.3266 55.3063 10.5731C55.5458 11.8155 56.592 12.5859 57.7945 12.4053ZM64.2244 13.4089C63.8127 13.3655 63.4139 13.2548 63.0534 13.0841C62.1528 12.6575 61.5244 11.8444 61.2992 10.8144C61.2579 10.6253 61.2522 10.537 61.2522 10.0897C61.2522 9.64298 61.2578 9.55498 61.2986 9.37332C61.5515 8.2462 62.2566 7.42058 63.3134 7.01436C63.7595 6.84286 64.1837 6.77885 64.7589 6.79623C65.4436 6.81692 65.9636 6.96559 66.509 7.29661C67.6839 8.00979 68.2586 9.43608 67.947 10.8661C67.5844 12.5308 66.0214 13.5984 64.2244 13.4089ZM64.9753 12.4037C65.5645 12.3138 66.0427 12.0068 66.3701 11.5081C67.0566 10.4627 66.8449 8.90448 65.9215 8.20733C65.7155 8.0518 65.4298 7.90998 65.1981 7.84833C64.9564 7.78398 64.4433 7.76883 64.18 7.81825C63.9454 7.86229 63.7231 7.94663 63.5004 8.07608C63.2712 8.20931 62.943 8.54033 62.8084 8.77399C62.2812 9.68946 62.3572 10.8934 62.9922 11.6871C63.4465 12.2548 64.1901 12.5236 64.9753 12.4037ZM46.714 13.3814C45.9091 13.2486 45.3662 12.8971 45.076 12.3209C44.9448 12.0604 44.9133 11.8997 44.9133 11.4904C44.9133 11.1872 44.9206 11.1032 44.9588 10.9644C45.1192 10.3814 45.604 9.94775 46.374 9.69852C47.0043 9.49451 47.6295 9.41158 48.7371 9.3851C49.1808 9.37449 49.2804 9.36653 49.3074 9.33956C49.3347 9.31226 49.3376 9.27034 49.3252 9.08526C49.2973 8.66744 49.1939 8.39715 48.9795 8.18101C48.6872 7.88643 48.2788 7.74473 47.722 7.74473C47.1053 7.74473 46.5173 7.95838 46.0352 8.35751C45.9771 8.40566 45.923 8.44505 45.915 8.44505C45.8929 8.44505 45.3027 7.73117 45.3027 7.70446C45.3027 7.66483 45.6315 7.41878 45.8491 7.29556C46.2295 7.08018 46.591 6.94711 47.0551 6.8516C47.3622 6.78842 48.069 6.77165 48.3961 6.81979C48.9905 6.90726 49.4622 7.12622 49.8139 7.47792C50.134 7.79801 50.3238 8.18124 50.4296 8.72093C50.4603 8.87739 50.4672 9.16734 50.4816 10.9068C50.4915 12.0997 50.5069 12.9595 50.5198 13.029C50.5317 13.0932 50.5421 13.1719 50.5429 13.204L50.5444 13.2624H50.0271C49.639 13.2624 49.5043 13.2558 49.4881 13.2359C49.4601 13.2017 49.4047 12.8442 49.3858 12.5762C49.3679 12.3207 49.3417 12.297 49.2318 12.4363C49.191 12.488 49.0609 12.6257 48.9427 12.7425C48.6222 13.0587 48.2783 13.2465 47.8294 13.3505C47.593 13.4053 46.9641 13.4227 46.714 13.3814ZM47.9014 12.4449C48.6261 12.3186 49.1551 11.7697 49.2917 11.0023C49.3233 10.8245 49.344 10.3999 49.3258 10.3027L49.3106 10.2217L48.7126 10.2337C47.6901 10.2543 47.0726 10.3673 46.6609 10.6092C46.2861 10.8295 46.1304 11.0824 46.1304 11.4708C46.1304 11.9737 46.4577 12.3316 47.0217 12.4454C47.2145 12.4843 47.6772 12.484 47.9014 12.4449ZM28.6323 13.2362C28.6267 13.2214 28.6246 11.8055 28.6275 10.0897L28.633 6.97014L29.2326 6.9645L29.8322 6.95887L29.8268 10.1053L29.8214 13.2518L29.232 13.2574C28.7718 13.2618 28.6403 13.2572 28.6323 13.2362ZM38.5648 13.2362C38.5595 13.2214 38.5513 11.8389 38.5464 10.164C38.5415 8.48908 38.5307 7.08288 38.5223 7.03911L38.5071 6.95953H39.0705C39.3804 6.95953 39.6387 6.96719 39.6445 6.97656C39.6503 6.98592 39.6659 7.21273 39.6792 7.48057C39.6925 7.74841 39.7106 7.97504 39.7194 7.98417C39.7508 8.01655 39.7966 7.9748 39.8699 7.84699C40.09 7.46351 40.5304 7.10684 41.0032 6.92917C41.4666 6.755 42.1751 6.74121 42.6491 6.89714C43.408 7.14678 43.9303 7.75822 44.1021 8.59795C44.1736 8.94782 44.1795 9.16352 44.1734 11.2145L44.1673 13.2518L43.5802 13.2574L42.9931 13.2631L42.9834 11.3156C42.9769 10.0086 42.9656 9.31238 42.9492 9.19843C42.8893 8.78246 42.7646 8.45585 42.5791 8.22919C42.4529 8.07498 42.2026 7.90734 42.0064 7.84567C41.8737 7.80392 41.8094 7.79787 41.504 7.7984C41.1808 7.79896 41.1408 7.80344 40.9841 7.85622C40.8907 7.88768 40.7527 7.94948 40.6775 7.99355C40.3241 8.20046 40.0033 8.62436 39.8805 9.04686C39.7732 9.41584 39.7776 9.32803 39.765 11.3524L39.7532 13.2518L39.1638 13.2574C38.7034 13.2618 38.5722 13.2572 38.5648 13.2362ZM51.6693 8.21161V3.16016L52.2582 3.16579L52.8471 3.17143V8.21161V13.2518L52.2582 13.2574L51.6693 13.2631V8.21161ZM67.883 13.2465C67.8832 13.2377 68.4415 12.5 69.1237 11.6071C69.8059 10.7142 70.3644 9.96687 70.3648 9.94637C70.3653 9.92588 69.8595 9.25119 69.2409 8.44705C68.6223 7.6429 68.1161 6.97912 68.1161 6.97197C68.1161 6.96483 68.4467 6.96149 68.8507 6.96456L69.5853 6.97013L70.3255 8.01C70.7326 8.58193 71.0806 9.06722 71.0987 9.08843C71.1168 9.10964 71.1431 9.12325 71.1572 9.11867C71.1712 9.11408 71.5303 8.6264 71.9553 8.03493L72.7278 6.95953H73.4275C73.984 6.95953 74.1229 6.96495 74.1065 6.98605C73.5274 7.73067 71.8845 9.90784 71.8846 9.93054C71.8846 9.94807 72.4407 10.6903 73.1204 11.5799C73.8001 12.4695 74.3618 13.2122 74.3687 13.2302C74.38 13.2594 74.3013 13.2623 73.6422 13.2574L72.9031 13.2518L72.0317 12.0315C71.3885 11.1308 71.1495 10.8113 71.1188 10.8113C71.0883 10.8113 70.845 11.1319 70.2022 12.0192C69.721 12.6836 69.3149 13.235 69.3 13.2445C69.2657 13.2662 67.8826 13.2681 67.883 13.2465ZM29.0468 5.38132C28.7989 5.32723 28.6084 5.17533 28.4977 4.94346C28.4497 4.84276 28.442 4.79899 28.442 4.62468C28.442 4.43961 28.4478 4.41086 28.511 4.28253C28.5928 4.1163 28.7261 3.98587 28.8946 3.90721C28.9991 3.85839 29.0416 3.85112 29.2166 3.85208C29.4688 3.85344 29.6049 3.90246 29.7733 4.05258C29.945 4.20559 30.0085 4.34508 30.0189 4.59211C30.0256 4.75052 30.0191 4.80556 29.9815 4.90529C29.8921 5.14238 29.6471 5.33783 29.3772 5.38727C29.2266 5.41484 29.1982 5.41433 29.0468 5.38132Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.29688,
    y: 3.16797,
    width: 2.66664,
    height: 2.66664,
    fill: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96387,
    y: 0.5,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63086,
    y: 0.5,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63086,
    y: 3.16797,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63086,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63086,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96387,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.29688,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.630859,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.630859,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63086,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63086,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96387,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96387,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 3.29688,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 3.29688,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 0.630859,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 0.630859,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2969,
    y: 0.5,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2969,
    y: 3.16797,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2969,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2969,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2969,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2969,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9639,
    y: 0.5,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9639,
    y: 3.16797,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9639,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9639,
    y: 8.49609,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9639,
    y: 11.168,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9639,
    y: 13.832,
    width: 2.66664,
    height: 2.66664,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96387,
    y: 3.16406,
    width: 2.66664,
    height: 2.66664,
    fill: "#333333"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96387,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "#333333"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 3.29785,
    y: 5.83203,
    width: 2.66664,
    height: 2.66664,
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalboxAttributionDark);
export default __webpack_public_path__ + "static/media/signalbox_attribution_dark.b5db2f85bf473cddd78c6daafdd22bfc.svg";
export { ForwardRef as ReactComponent };